import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppAccess } from './app-access.types';

interface AppAccessDialogData {
  access: AppAccess;
  message: string;
}

@Component({
  selector: 'qas-app-access-dialog',
  templateUrl: './app-access-dialog.component.html',
  styleUrls: [ './app-access-dialog.component.scss' ]
})
export class AppAccessDialogComponent {
  static readonly AppAccess = AppAccess;
  readonly AppAccess = AppAccessDialogComponent.AppAccess;

  constructor(
    public dialogRef: MatDialogRef<AppAccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AppAccessDialogData) {}

  close(): void {
    this.dialogRef.close();
  }
}
